import * as React from "react";
import { Box, Card,styled, TextField } from "@mui/material";
import FlexBox from "../../components/FlexBox";
import LightTextField from "../../components/LightTextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { useNavigate } from "react-router-dom";
import {  H3, Small } from "../../components/Typography";
import Button from "@mui/material/Button";
import { load, remove, save } from "../../constants/storage";
import { getUserDetail } from "../../redux/actions/UserAction";
import toast from "react-hot-toast";
import { userPincode, userInfoUpdate } from "../../redux/actions/LoginAction";
import { useAppDispatch } from "../../store/hooks";
import * as Models from "../../models";
import { UserInfoRequest, PincodeRequest } from "../../models";
import DashboardNavbar from "../../components/DashboardNavbar";

// styled ../../components
const StyledCard = styled(Card)(() => ({
  position: "relative",
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
}));
type FormValues = {
  firstname: string;
  lastname: string;
  email: string;
  line1: string;
  pincode: string;
  city_name: string;
  state_name: string;
  country: string;
  gender: string;
  dob: any;
};

type FormErrors = {
  firstname?: string;
  lastname?: string;
  email?: string;
  line1?: string;
  pincode?: string;
  city_name?: string;
  state_name?: string;
  country?: string;
  gender?: string;
  dob?: any;
};
const UserInformaion = () => {
  const [formValues, setFormValues] = React.useState<FormValues>({
    firstname: "",
    lastname: "",
    email: "",
    line1: "",
    pincode: "",
    city_name: "",
    state_name: "",
    country: "INDIAN",
    gender: "",
    dob: "",
  });
  const [formErrors, setFormErrors] = React.useState<FormErrors>({});
  let navigate = useNavigate();
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
    setFormErrors({ ...formErrors, [name]: "" }); // clear any previous errors for this field
  }
  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 18); // Set the minimum date to 18 years ago
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      let userDetail: any = load("userData");
      let token: any = load("token");
      let finalUser = JSON.parse(userDetail);
      getData(finalUser.id, finalUser.mobile, finalUser.refcode, token);
    }
  };

  const getData = (
    id: number,
    mobile: string,
    patnerId: string,
    token: string
  ) => {
    const data: UserInfoRequest = {
      id: id,
      mobile: mobile,
      partner: patnerId,
    };
    dispatch(getUserDetail(data, `bearer ${token}`))
      .then(async (response: any) => {
        setFormValues(response.data);
      })
      .catch((error: any) => {
        console.log("----------error--------------", error);
      });
  };

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const regex = /^[a-zA-Z \\s]+$/;
    const newErrors: FormErrors = {};
    if (formValues.firstname.trim() === "") {
      newErrors.firstname = "Fist name is required";
    }
    if (formValues.lastname.trim() === "") {
      newErrors.lastname = "Last name is required";
    }
    if (!regex?.test(formValues.firstname)) {
      newErrors.firstname = "Special character not allowed in firstname";
    }
    if (!regex?.test(formValues.lastname)) {
      newErrors.lastname = "Special character not allowed in lastname";
    }
    if (formValues.email.trim() === "") {
      newErrors.email = "Email is required";
    }
    if (!emailRegex.test(formValues.email.toUpperCase())) {
      newErrors.email = "Please enter a valid email";
    }
    if (formValues.line1.trim() === "") {
      newErrors.line1 = "Address is required";
    }
    if (formValues.line1?.length < 15) {
      newErrors.line1 = "Address should be more then 15 characters";
    }
    if (formValues.pincode.trim() === "") {
      newErrors.pincode = "Pin Code is required";
    }

    // if there are errors, update state_name with them
    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
    } else {
      let userDetail: any = load("userData");
      let token: any = load("token");
      let finalUser = JSON.parse(userDetail);

      const firstName = formValues.firstname.replace(/\s+/g, " ").trim();
      const lastName = formValues.lastname.replace(/\s+/g, " ").trim();
      const Email = formValues.email.replace(/\s+/g, " ").trim();
      const Pincode = formValues.pincode.replace(/\s+/g, " ").trim();
      const Line1 = formValues.line1.replace(/\s+/g, " ").trim();

      const data: Models.UpdateUserRequest = {
        dob: formValues?.dob,
        gender: formValues.gender.toUpperCase(),
        mobile: finalUser?.mobile,
        id: finalUser?.id,
        partner: finalUser?.refcode,
        firstname: firstName,
        lastname: lastName,
        email: Email,
        email_article_enable: true,
        whatsapp_article_enable: true,
        sms_article_enable: true,
        pincode: Pincode,
        state: formValues?.state_name,
        city: formValues?.city_name,
        latitude: 12.972,
        longitude: 77.595,
        address: Line1,
        nationality: "INDIAN",
      };
      dispatch(userInfoUpdate(data, `bearer ${token}`))
        .then(async (response: any) => {
          if (response.message === "User Profile Updated Successfully") {
            save("userData", JSON.stringify(response?.data[0]));
            navigate("/kycinformation", {
              state: {
                KYCStatus: 0,
              },
            });
            toast.success(response.message);
          } else {
            toast.error(response.message);
          }
        })
        .catch((error: any) => {
          console.log("---------userInfoUpdate--------------error", error);
        });
    }
  }
  const getUserPincode = async () => {
    let token = load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const data: PincodeRequest = {
      id: userDetails?.id,
      mobile: userDetails?.mobile,
      partner: userDetails.refcode,
      pincode: formValues.pincode,
    };
    dispatch(userPincode(data, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.message === "Pincode details fetch Successfully") {
          setFormValues((prevState) => ({
            ...prevState,
            city_name: response.bankdata?.data?.city || "",
          }));
          setFormValues((prevState) => ({
            ...prevState,
            state_name: response.bankdata?.data?.state || "",
          }));
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };
  const handleChangeGenderValue = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFormValues((prevState) => ({
      ...prevState,
      gender: (event.target as HTMLInputElement).value,
    }));
  };
  const handleTextBlur = () => {
    getUserPincode();
  };
  return (
    <>
      <DashboardNavbar />
      <StyledCard sx={mainContainer}>
        <H3 sx={headingText}>Please verify your details</H3>
        <Box
          sx={{
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            display: "flex",
          }}
        >
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <FlexBox
              justifyContent="space-between"
              flexWrap="wrap"
              flexDirection={"row"}
            >
              <LightTextField
                name="firstname"
                label="First Name"
                sx={textInputStyles}
                value={formValues.firstname ? formValues.firstname : ""}
                error={!!formErrors.firstname}
                helperText={formErrors.firstname}
                onChange={handleChange}
              />

              <LightTextField
                name="lastname"
                label="Last Name"
                sx={textInputStyles}
                value={formValues.lastname ? formValues.lastname : ""}
                error={!!formErrors.lastname}
                helperText={formErrors.lastname}
                onChange={handleChange}
              />
            </FlexBox>
            <FlexBox flexWrap="wrap" sx={rowContainer}>
              <LightTextField
                name="email"
                label="Email"
                sx={textInputStyles}
                value={formValues.email ? formValues.email : ""}
                error={!!formErrors.email}
                helperText={formErrors.email}
                onChange={handleChange}
              />
              <TextField
                name="dob"
                label="Date of Birth"
                type="date"
                inputProps={{
                  max: minDate.toISOString().split("T")[0], // Set the maximum date
                }}
                sx={textInputStyles}
                value={formValues.dob}
                error={!!formErrors.dob}
                helperText={formErrors.dob}
                onChange={handleChange}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FlexBox>
            <FlexBox flexWrap="wrap" sx={rowContainer}>
              <LightTextField
                name="line1"
                label="Address"
                sx={textInputStyles}
                value={formValues.line1 ? formValues.line1 : ""}
                error={!!formErrors.line1}
                helperText={formErrors.line1}
                onChange={handleChange}
              />
              <LightTextField
                name="pincode"
                label="PIN Code"
                sx={textInputStyles}
                onBlur={handleTextBlur}
                value={formValues.pincode ? formValues.pincode : ""}
                error={!!formErrors.pincode}
                helperText={formErrors.pincode}
                onChange={handleChange}
              />
            </FlexBox>
            <FlexBox sx={rowContainer} marginBottom={2}>
              <LightTextField
                disabled
                name="city_name"
                label="City"
                sx={textInputStyles}
                value={formValues.city_name ? formValues.city_name : ""}
                error={!!formErrors.city_name}
                helperText={formErrors.city_name}
                onChange={handleChange}
              />
              <LightTextField
                disabled
                name="state_name"
                label="State"
                sx={textInputStyles}
                value={formValues.state_name ? formValues.state_name : ""}
                error={!!formErrors.state_name}
                helperText={formErrors.state_name}
                onChange={handleChange}
              />
            </FlexBox>
            <FlexBox sx={rowContainer} marginBottom={2}>
              <LightTextField
                disabled
                name="country"
                label="Country"
                sx={textInputStyles}
                value={formValues.country ? formValues.country : "INDIAN"}
                error={!!formErrors.country}
                helperText={formErrors.country}
                onChange={handleChange}
              />
            </FlexBox>
            <Small fontSize={18} sx={genderText} color="#595959">
              Gender
            </Small>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={formValues.gender?.toLowerCase()}
              onChange={handleChangeGenderValue}
            >
              <FormControlLabel
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: "400",
                }}
                value="female"
                control={
                  <Radio
                    sx={{
                      color: "#FFF5D1",
                      "&.Mui-checked": {
                        color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                      },
                    }}
                  />
                }
                label="Female"
              />
              <FormControlLabel
                value="male"
                control={
                  <Radio
                    sx={{
                      color: "#FFF5D1",
                      "&.Mui-checked": {
                        color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                      },
                    }}
                  />
                }
                label="Male"
              />
            </RadioGroup>
            <Box sx={sxStyleBox1}>
              <Button
                type="submit"
                variant="contained"
                size="medium"
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1.5,
                  fontFamily: "'Poppins', sans-serif",
                  width: {
                    xs: "100%",
                    sm: "100%",
                    md: "40%",
                  },
                  alignSelf: "center",
                  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                }}
              >
                Proceed
              </Button>
            </Box>
          </form>
        </Box>
      </StyledCard>
    </>
  );
};

export default UserInformaion;
const mainContainer = {
  margin: {
    xs: 2,
    sm: 2,
    md: 5,
  },
  marginLeft: {
    xs: 2,
    sm: 2,
    md: 20,
  },
  marginRight: {
    xs: 2,
    sm: 2,
    md: 20,
  },
  padding: {
    xs: 2,
    sm: 2,
    md: 3,
  },
};
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "49%",
  },
  marginTop: {
    xs: 2,
    sm: 2,
    md: 4,
  },
};
const rowContainer = {
  flexDirection: {
    xs: "column",
    sm: "column",
    md: "row",
  },
  justifyContent: "space-between",
};
const headingText = {
  textAlign: "left",
  fontFamily: "'Poppins', sans-serif",
};
const genderText = {
  mt: 3,
  textAlign: "left",
  fontFamily: "'Poppins', sans-serif",
};
const sxStyleBox1 = {
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  display: "flex",
  mt: 2,
};
